module.exports = __webpack_public_path__ + "static/media/Gilroy-Semibold-Italic.8dd42df1.ttf";